// test2689
(2689 && 0);
